var __vue_script__, __vue_template__
require("-!style-loader!css-loader!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-ec920f9c&file=RingLoader.vue!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./RingLoader.vue")
__vue_script__ = require("-!babel-loader!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./RingLoader.vue")
__vue_template__ = require("-!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./RingLoader.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/Users/greyby/Workspace/javascript/vuejs/vue-spinner/src/RingLoader.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}


/*****************
 ** WEBPACK FOOTER
 ** ./src/RingLoader.vue
 ** module id = 84
 ** module chunks = 0
 **/